<template>
  <div class="col-md-3">
    <form-group-input
      ref="input"
      type="text"
      :label="label"
      :readonly="readonly"
      :disabled="conjugeDisabled"
      :value="value"
      :name="name"
      :data-vv-as="label"
      :placeholder="placeholder"
      @input="$emit('input', $event)"
      v-validate="{ required: required, date_format: 'dd/MM/yyyy' }"
      v-mask="'##/##/####'"
      masked="true"
    />
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator"],
  name: "c-nascimento-conjuge",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean
  },
  computed: {
    crm() {
      return this.$store.state.crm;
    }
  },
  asyncComputed: {
    conjugeDisabled() {
      let enabled = this.crm.conjuge;

      return !enabled;
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Crm/NascimentoConjuge.vue